/**
 * Code-split entry for the in-chat annotated document viewer (#20423).
 *
 * InChatDocumentViewer pulls DocumentViewerCore and with it the whole
 * react-pdf/pdfjs stack — hundreds of KB that a static import wires into the
 * chat bundle although the drawer only ever renders after a source click.
 * This gate reads just the (light) viewer store and fetches the heavy module
 * on first open; the chunk stays cached, so re-opens are instant.
 */

import { lazy, Suspense } from "react";

import { useSourceViewerStore } from "../../stores/sourceViewerStore";

const InChatDocumentViewer = lazy(() => import("./InChatDocumentViewer"));

const InChatDocumentViewerLazy = () => {
  const open = useSourceViewerStore((s) => s.open);
  const home = useSourceViewerStore((s) => s.home);
  const sdrId = useSourceViewerStore((s) => s.sdrId);

  // Same mount gate the viewer shell applies internally — kept here so the
  // lazy chunk isn't even requested until there is something to show.
  if (!open || home == null || sdrId == null) return null;

  return (
    <Suspense fallback={null}>
      <InChatDocumentViewer />
    </Suspense>
  );
};

export default InChatDocumentViewerLazy;
